<div class="app-wrapper">
  <app-header></app-header>
  <div class="app-page">
    <router-outlet></router-outlet>
  </div>  
</div>